import { attr, html } from '@tempots/dom'

/**
 * Thin vertical strip placed between an embedded PDF preview iframe and the
 * window edge. The iframe swallows drag events, so a file dragged in from
 * that edge would never trigger the page drop zone; this strip is parent-
 * document territory, so crossing it fires dragenter and brings up
 * ResumeDropOverlay (which then shields the iframe).
 */
export function DropCatchGutter() {
  return html.div(
    attr.class('w-5 flex-none bg-[#fffaf8]'),
    attr.role('presentation')
  )
}

/**
 * Full-page overlay for PageDropZone's onDragContent slot: shown while a
 * file is dragged anywhere over the page, making the page-wide drop target
 * visible. It deliberately captures pointer events: drag events on it still
 * bubble to PageDropZone's document listeners, and it shields embedded PDF
 * iframes (the workspace preview), which would otherwise swallow the drop.
 */
export function ResumeDropOverlay() {
  return html.div(
    attr.class(
      'fixed inset-0 z-50 flex items-center justify-center bg-teal-900/40 backdrop-blur-sm'
    ),
    html.div(
      attr.class(
        'flex flex-col items-center gap-2 border-4 border-dashed border-white rounded-2xl bg-teal-700/95 px-10 py-8 sm:px-16 sm:py-12 text-white shadow-2xl'
      ),
      html.div(attr.class('text-5xl leading-none select-none'), '📄'),
      html.div(
        attr.class('text-xl sm:text-2xl font-bold'),
        'Drop your resume anywhere'
      ),
      html.div(
        attr.class('text-sm text-teal-100'),
        html.span(attr.class('font-mono'), '.pdf'),
        ', ',
        html.span(attr.class('font-mono'), '.docx'),
        ', ',
        html.span(attr.class('font-mono'), '.doc'),
        ', images, and more'
      )
    )
  )
}
